import { Injectable } from "@angular/core";
import { Subject, forkJoin } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../shared";

@Injectable()
export class ClassroomAttendanceService {
	constructor(private httpclientService: HttpclientService) {}

	private subjectCancel = new Subject<any>();
	cancelEdit() {
		this.subjectCancel.next(null);
	}

	onCancelEdit(): Observable<any> {
		return this.subjectCancel.asObservable();
	}

	private subjectFilterChanged = new Subject<any>();

	sectionChanged(params) {
		this.subjectFilterChanged.next(params);
	}

	onSectionChange(): Observable<any> {
		return this.subjectFilterChanged.asObservable();
	}

	private subjectloadData = new Subject<any>();

	LoadData() {
		this.subjectloadData.next(null);
	}

	onLoadata(): Observable<any> {
		return this.subjectloadData.asObservable();
	}

	private subjectSaveAttendanceCompleted = new Subject<any>();

	SaveAttendanceCompleted() {
		this.subjectSaveAttendanceCompleted.next(null);
	}

	onSaveAttendanceCompleted(): Observable<any> {
		return this.subjectSaveAttendanceCompleted.asObservable();
	}

	StudentGetList(SectionScheduleDetailID, ClassDate, AllSections) {
		var postResult$ = new Subject();
		var url = "attendance/StudentGetList?SectionScheduleDetailID=" + SectionScheduleDetailID + "&Classdate=" + ClassDate + "&AllSections=" + AllSections;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ClassAttendanceModify(lstClass, ClassDate) {
		var postResult$ = new Subject();
		var url = "attendance/ClassAttendanceModify";

		//
		// Latest version (Pre 10.9)
		// SQL Error with webservices (Many requests with lists that have 1 item
		// hits deadlock trying to run 2 SP's that use ClassAttendance/ClassAttendanceStudent)
		// (
		//    Methods starts on 1st item, calls 1st SP
		//    then calls 2nd SP,
		//    Method starts on 2nd item and calls 1st SP that causes a conflict
		// )
		//
		//
		// var current$ = this.httpclientService.createAuthorizationHeader();
		// current$.then(
		//   res => {
		//     var pr = [];
		//     for (var i = 0; i < lstClass.length; i++) {

		//       var subList = [];
		//       subList.push(lstClass[i]);

		//       var params = { lstClass: subList, ClassDate: ClassDate };

		//       var promise$ = this.httpclientService.postParralle(url, params, res);
		//       pr.push(promise$);
		//     }

		//     forkJoin(pr).subscribe(results => {
		//       postResult$.next(results);
		//     });
		//   })

		// return postResult$;

		//
		// Brought back in 10.9 (was commented out for some reason?)
		// Shouldn't hit deadlocks if you pass the whole list at once
		//
		var params = { lstClass: lstClass, ClassDate: ClassDate };

		var promise$ = this.httpclientService.post(url, params);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	studentPhotoGet(personID) {
		var postResult$ = new Subject();
		var url = "PersonPhoto/ThumbnailGet?PersonID=" + personID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ClassroomGetScanSound(SchoolID) {
		var postResult$ = new Subject();
		var url = "attendance/ClassroomGetScanSound?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
